module.exports = __webpack_public_path__ + "media/images/github_copilot_sidebar_banner_02-a055fcde5e2db4196178886a10057f2f.png";